import e from"react";import y from"@mui/material/Typography";function a({text:p,tag:t="p",variant:o="body1",...r}){return e.createElement(y,{component:t,variant:o,...r},p)}export{a as default};
